export const SET_PRINT_QUEUE_MULTIPLE_IFRAME_ACTIVE =
	'SetPrintQueueMultipleIframeActive';
export const SET_PRINT_QUEUE_MULTIPLE_ROW_KEY = 'SetPrintQueueMultipleRowKey';
export const SET_PRINT_QUEUE_MULTIPLE_LOADED = 'SetPrintQueueMultipleLoaded';
